module.exports = __webpack_public_path__ + "static/media/coffee_image_card_woman_on_shop_mobile.9797ee68.jpg";